module.exports = __webpack_public_path__ + "img/pr-6.759c9f00.png";